<template>
  <el-dialog
    title="資料上傳"
    :visible.sync="innerVisible"
    :close-on-click-modal="false"
    @close="handleDlgClose"
  >
    <el-form
      :model="form"
      ref="form"
      :rules="rules"
      :disabled="isUploadControlDisabled()"
    >
      <el-form-item label="加密" :label-width="formLabelWidth" prop="isEncrypt">
        <el-switch
          v-model="upload.data.isEncrypt"
          active-text="啟用"
          inactive-text="關閉"
        >
        </el-switch>
      </el-form-item>

      <div v-if="upload.data.isEncrypt">
        <el-form-item
          label="失效日模式"
          :label-width="formLabelWidth"
          prop="encryptExpiredMode"
        >
          <el-switch
            :disabled="!upload.data.isEncrypt"
            v-model="upload.data.encryptExpiredMode"
            active-value="absolute"
            inactive-value="relative"
            active-text="指定日期"
            inactive-text="相對日期"
          >
          </el-switch>
        </el-form-item>
        <el-form-item
          v-if="upload.data.encryptExpiredMode == 'absolute'"
          label="失效日"
          :label-width="formLabelWidth"
          prop="endDate"
        >
          <el-date-picker
            :disabled="!upload.data.isEncrypt"
            v-model="upload.data.endDate"
            :picker-options="pickerOptions"
            type="date"
            value-format="timestamp"
            placeholder="指定失效日"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item
          v-if="upload.data.encryptExpiredMode == 'relative'"
          label="下載後"
          :label-width="formLabelWidth"
          prop="endDate"
        >
          <el-input-number
            v-model="upload.data.endDateAmount"
            :min="1"
            :max="999"
          >
          </el-input-number>
          <el-select v-model="upload.data.endDateUnit" placeholder="單位">
            <el-option label="日" value="days"></el-option>
           </el-select
          >失效
        </el-form-item>
      </div>

      <el-form-item label="" label-width="60px" prop="replaceOld" style="margin-bottom:-5px">
        <el-checkbox v-model="form.replaceOld"
          >音檔名稱相同時，取代舊檔</el-checkbox
        >
      </el-form-item>

      <AssetUpload
        ref="upload"
        :action="uplaodUrl"
        :accept="acceptFileTypes"
        :before-upload="beforeUpload"
        :on-success="handleSuccess"
        :on-change="handleChange"
        :on-error="handleError"
        :on-remove="handleRemove"
        :multiple="upload.multiple"
        :headers="upload.headers"
        :limit="upload.limit"
        :auto-upload="upload.autoUpload"
        :data="upload.data"
        :disabled="isUploadElmDisabled()"
        drag
      >
        <div class="el-upload__text">
          <div class="mt-5 mb-0">
            <el-button size="small" type="primary" @click="selectAssets(false)"
              >上傳檔案</el-button
            >
            <el-button size="small" type="primary" @click="selectAssets(true)"
              >上傳資料夾</el-button
            >
          </div>
          <div class="mt-0">
            或將檔案拖至此處
            <i class="el-icon-upload" style="margin-top: 15px"></i>
          </div>
        </div>

        <div slot="tip" class="el-upload__tip">
          <div v-if="loading === 'idle'">(目前只能上傳音檔及LRC、SRT檔案)</div>
          <div v-else>
            上傳檔案({{ form.fileList.length + faildureCount }})： 成功({{
              successCount
            }}) / 失敗({{ faildureCount }}) / 忽略({{ skipCount }})
          </div>
        </div>
      </AssetUpload>
    </el-form>
    <template #footer class="dialog-footer">
      <el-button @click="cancelUpload">{{ getCancelBtnTitle() }}</el-button>

      <el-button
        v-loading="isUploadBtnLoading()"
        type="primary"
        :disabled="isUploadingBtnDisabled()"
        @click="uploadItem"
        >開始上傳</el-button
      >
    </template>
  </el-dialog>
</template>

<script>
import { UPLOAD_STATE } from "@/appConfig.js";
import API from "@/api/";
import AssetUpload from "../../pkg/upload";
export default {
  components: {
    AssetUpload,
  },
  model: {
    prop: "visible",
    event: "toggleVisible",
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    parentId: {
      type: Number,
      default: null,
    },
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("toggleVisible", val);
      },
    },
  },
  data() {
    return {
      containingFolders: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > 4102358400000;
        },
      },
      successCount: 0,
      faildureCount: 0,
      skipCount: 0,
      uplaodUrl:
        (process.env.VUE_APP_APIURL
          ? process.env.VUE_APP_APIURL
          : window.location.origin.replace("//admin.", "//api.") + "/") +
        "blob/upload",
      //acceptFileTypes: "audio/mp3,audio/x-ms-wma,video/x-ms-wma,audio/x-m4a,audio/flac",
      acceptFileTypes: "audio/*,.wma,.lrc,.bmp,.slideshow,.srt,.txt,.slide",
      upload: {
        headers: { Authorization: "" },
        multiple: true,

        //@TODO: configure the max limit
        limit: 99999,
        autoUpload: false,
        data: {
          //parentId: this.parentId,
          isEncrypt: false,
          encryptExpiredMode: "absolute",
          endDate: null,
          endDateAmount: 7,
          endDateUnit: "days",
        },
      },
      loading: UPLOAD_STATE.IDLE,
      rules: {
        name: [
          //{ required: true, message: "請輸入資料夾名稱", trigger: "blur" },
          //{ validator: validateName, trigger: "blur" },
        ],
      },
      formLabelWidth: "100px",
      form: {
        fileList: [],
        replaceOld: false,
      },
      showLog: false,
    };
  },
  methods: {
    selectAssets(inputFolder) {
      this.$refs.upload.triggerInput(inputFolder);
    },
    getCancelBtnTitle() {
      if (this.loading === UPLOAD_STATE.LOADED) {
        return "關閉";
      } else {
        return "取消";
      }
    },
    isUploadControlDisabled() {
      return (
        this.loading === UPLOAD_STATE.LOADING ||
        this.loading === UPLOAD_STATE.LOADED ||
        this.loading === UPLOAD_STATE.CANCELLED
      );
    },
    isUploadElmDisabled() {
      return (
        this.loading === UPLOAD_STATE.LOADED ||
        this.loading === UPLOAD_STATE.CANCELLED
      );
    },
    isUploadBtnLoading() {
      return this.loading === UPLOAD_STATE.LOADING;
    },
    isUploadingBtnDisabled() {
      if (this.loading === UPLOAD_STATE.IDLE && this.form.fileList.length > 0) {
        return false;
      }
      return true;
    },
    handleSuccess(_, __, fileList) {
      //console.log(`handleSuccess: fileList.length = ${fileList.length}`);
      //handleSuccess() {
      //console.log(response);
      //console.log(file);
      //console.log(fileList);
      //console.log(`handleSuccess: response = ${JSON.stringify(response)},\n\n file = ${JSON.stringify(file)}, \n\n fileList = ${JSON.stringify(fileList)}`);

      this.successCount++;
      //this.$message({
      //message: `上傳成功:${file.name}`,
      //type: "success",
      //});

      if (this.successCount === fileList.length) {
        this.loading = UPLOAD_STATE.LOADED;

        if (this.faildureCount === 0) {
          this.$message({
            message: `所有檔案上傳成功`,
            type: "success",
          });
          this.innerVisible = false;

          //execute in dialog closed handler instead
          //this.$store.dispatch("asset/getAssetContent", null);
        }
      } else {
        //if ((this.successCount + this.faildureCount) % 2 == 0) {
          this.$refs["upload"].submit();
        //}
      }
    },

    handleRemove(_, fileList) {
      //console.log(`handleRemove: fileList.length = ${fileList.length}`);
      if (this.loading !== UPLOAD_STATE.IDLE) {
        if (this.successCount === fileList.length) {
          this.loading = UPLOAD_STATE.LOADED;
        } else {
          this.$refs["upload"].submit();
        }
      }
    },

    handleError(err, file, fileList) {
      //console.log(`handleError: fileList.length = ${fileList.length}`);
      this.$message.error(`${file.name}上傳失敗: ${err.message}`);
      this.faildureCount++;

      if (this.successCount === fileList.length) {
        this.loading = UPLOAD_STATE.LOADED;
      } else {
        if ((this.successCount + this.faildureCount) % 4 == 0) {
          this.$refs["upload"].submit();
        }
      }
    },

    handleChange(_, fileList) {
      this.form.fileList = fileList;
    },

    beforeUpload(file) {
      this.showLog && console.log(`beforeUpload: file name = ${file.name}`);
      if (!this.upload.data.endDate) {
        this.upload.data.endDate = 4102358400000;
      }
      if (
        new Date().getTime() / 1000 + 60 >
          this.$store.state.auth.access_token_exp &&
        this.$store.state.auth.access_token_exp > 0
      ) {
        return this.$store.dispatch("auth/refresh", null).then(() => {
          this.upload.headers.Authorization = `Bearer ${this.$store.state.auth.access_token}`;
          return this.getEmbededData(file);
          //return true;
        });
      } else {
        if (this.$store.state.auth.access_token) {
          this.upload.headers.Authorization = `Bearer ${this.$store.state.auth.access_token}`;
          return this.getEmbededData(file);
          //return true;
        } else {
          return false;
        }
      }
    },

    //return: the data to be embeded with upload data, wrapped with a promise object
    getEmbededData(file) {
      //console.log(`getEmbededData: file.pathName = ${file.pathName}`);

      //NOTE: "pathName" attribute has been set by revised <Upload> component; return "" for the normal file
      const filePath = file.pathName;
      this.show && console.log(`getEmbededData: filePath = ${filePath}`);
      if (!filePath) {
        this.show &&
          console.log(`getEmbededData.flatFile: parentId = ${this.parentId}`);

        if (this.form.replaceOld) {
          return Promise.resolve({ data: { parentId: this.parentId } });
        } else {
          const valParams = {
            parent: this.parentId,
            name: file.name,
            isLeaf: true,
          };
          return API.asset.validateName(valParams).then(
            resVal => {
              if (resVal.data) {
                this.show &&
                  console.log(
                    `getEmbededData: verify name = ${file.name}, existent assetId = ${resVal.data}`
                  );
                this.skipCount++;
                return { skip: true };
              } else {
                return { data: { parentId: this.parentId } };
                //return Promise.resolve({ data: { parentId: this.parentId } });
              }
            },
            () => ({ skip: true })
          );
        }
      } else {
        if (this.form.replaceOld) {
          return this.getFolderIdFromFilePath(filePath).then(folderId => ({
            data: { parentId: folderId },
          }));
        } else {
          const idx = filePath.lastIndexOf("/");
          const fileName = idx === -1 ? filePath : filePath.slice(idx + 1);
          return this.getFolderIdFromFilePath(filePath).then(folderId => {
            const valParams = {
              parent: folderId,
              name: fileName,
              isLeaf: true,
            };
            return API.asset.validateName(valParams).then(
              resVal => {
                if (resVal.data) {
                  this.show &&
                    console.log(
                      `getEmbededData: verify name = ${file.name}, existent assetId = ${resVal.data}`
                    );
                  this.skipCount++;
                  return { skip: true };
                } else {
                  return { data: { parentId: folderId } };
                }
              },
              () => ({ skip: true })
            );
          });
        }
      }
    },

    //return: the folder's assetId of the contained file, wrapped with a promise object
    getFolderIdFromFilePath(filePath) {
      const idx = filePath.lastIndexOf("/");
      if (idx === -1) {
        this.show &&
          console.log(
            `getFolderIdFromFilePath.noFolder: returned folderId = ${JSON.stringify(
              this.parentId
            )}`
          );
        return Promise.resolve(this.parentId);
      } else {
        const folderPath = filePath.slice(0, idx);
        return this.getFolderIdFromFolderPath(folderPath);
      }
    },

    //return: the folder's assetId of the folderPath, wrapped with a promise object
    getFolderIdFromFolderPath(folderPath) {
      this.show &&
        console.log(`getFolderIdFromFolderPath: folderPath = ${folderPath}`);
      const foundFd = this.containingFolders.find(fd => fd.path === folderPath);
      if (foundFd) {
        if (foundFd.folderId) {
          this.show &&
            console.log(
              `getFolderIdFromFolderPath.directFound: folderPath = ${folderPath} folderId = ${foundFd.folderId}`
            );
          return Promise.resolve(foundFd.folderId);
        } else {
          this.show &&
            console.log(
              `getFolderIdFromFolderPath.waitForPendingPromise: folderPath = ${folderPath}`
            );
          this.show && console.assert(foundFd.promise && foundFd.promise.then);
          return foundFd.promise.then(res => {
            this.show &&
              console.log(
                `getFolderIdFromFolderPath.pendingPromise.then: folderPath = ${folderPath} folderId = ${res.data.id}`
              );
            return res.data.id;
          });
        }
      } else {
        const idx = folderPath.lastIndexOf("/");
        if (idx === -1) {
          //NOTE: the pending promise, p, will return the whole response object, instead of the folderId
          const p = new Promise((resolve, reject) => {
            const valParams = {
              parent: this.parentId,
              name: folderPath,
              isLeaf: false,
            };
            API.asset.validateName(valParams).then(
              resVal => {
                if (resVal.data) {
                  this.show &&
                    console.log(
                      `getFolderIdFromFolderPath.folderFromAPI: folderPath = ${folderPath}, folderId = ${resVal.data}`
                    );
                  fdObj.folderId = resVal.data;
                  resolve({
                    data: {
                      id: resVal.data,
                    },
                  });
                } else {
                  const params = {
                    name: folderPath,
                    parentId: this.parentId,
                    ...this.upload.data,
                  };

                  API.asset.createFolder(params).then(
                    resCreate => {
                      this.show &&
                        console.log(
                          `getFolderIdFromFolderPath.create: folderPath = ${folderPath}, folderId = ${resCreate.data.id}`
                        );
                      resolve(resCreate);
                    },
                    err => reject(err)
                  );
                }
              },
              err => reject(err)
            );
          });

          const fdObj = {
            path: folderPath,
            folderId: null,
            promise: p,
          };
          this.containingFolders.push(fdObj);

          return p.then(res => {
            this.show &&
              console.log(
                `getFolderIdFromFolderPath.directCreate: folderPath = ${folderPath} folderId = ${res.data.id}`
              );
            fdObj.folderId = res.data.id;
            return res.data.id;
          });
        } else {
          const parentFdPath = folderPath.slice(0, idx);
          const pp = new Promise((resolve, reject) => {
            this.getFolderIdFromFolderPath(parentFdPath).then(
              resParentId => {
                this.show &&
                  console.log(
                    `getFolderIdFromFolderPath.hasParent: folderPath = ${folderPath}, parentFolderId = ${resParentId}`
                  );

                const valParams = {
                  parent: resParentId,
                  name: folderPath.slice(idx + 1),
                  isLeaf: false,
                };
                API.asset.validateName(valParams).then(
                  resVal => {
                    if (resVal.data) {
                      this.show &&
                        console.log(
                          `getFolderIdFromFolderPath.hasParent.folderFromAPI: folderPath = ${folderPath}, folderId = ${resVal.data}`
                        );
                      fdObj.folderId = resVal.data;
                      resolve({
                        data: {
                          id: resVal.data,
                        },
                      });
                    } else {
                      const params = {
                        name: folderPath.slice(idx + 1),
                        parentId: resParentId,
                        ...this.upload.data,
                      };

                      API.asset.createFolder(params).then(
                        resCreate => {
                          this.show &&
                            console.log(
                              `getFolderIdFromFolderPath.hasParent.create: folderPath = ${folderPath} folderId = ${resCreate.data.id}`
                            );
                          fdObj.folderId = resCreate.data.id;
                          //@TODO: release p from fdObj?
                          //NOTE: the pending promise, pp,  will return the whole response object, instead of folderId
                          resolve(resCreate);
                        },
                        err => reject(err)
                      );
                    }
                  },
                  err => reject(err)
                );
              },
              err => reject(err)
            );
          });

          const fdObj = {
            path: folderPath,
            folderId: null,
            promise: pp,
          };
          this.containingFolders.push(fdObj);

          return pp.then(res3 => {
            return res3.data.id;
          });
        }
      }
    },

    uploadItem() {
      if (this.loading === UPLOAD_STATE.IDLE) {
        if (this.form.fileList.length > 0) {
          this.$refs["upload"].submit();
          this.loading = UPLOAD_STATE.LOADING;
        }
      }
    },
    cancelUpload() {
      this.innerVisible = false;
    },
    handleDlgClose() {
      if (this.loading === UPLOAD_STATE.LOADING) {
        this.$refs["upload"].abort();
        this.loading = UPLOAD_STATE.CANCELLED;
      }

      //NOTE: if there is partial success and partial failure before cancellation, refresh the assetContnet
      //      is required to show the upload success items
      this.$store.dispatch("asset/getAssetContent", null);
    },
  },
};
</script>

<style></style>
